// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b264dc9c","977":"83aac2ce"}[chunkId] + ".chunk.js";
};